import { render, staticRenderFns } from "./spin.vue?vue&type=template&id=06219c74&scoped=true&"
import script from "./spin.vue?vue&type=script&lang=js&"
export * from "./spin.vue?vue&type=script&lang=js&"
import style0 from "./spin.vue?vue&type=style&index=0&id=06219c74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06219c74",
  null
  
)

export default component.exports